import { CSSProperties } from "react";
import { CampaignType, PlaybookType } from "modules/Const";
import { CampaignMetadata } from "modules/Types";
import { getCampaignTypeInfo, styx, clsx } from "modules/Utils";
import Icon from "./Icon";
import Sty from "modules/Sty";
import Colors from "modules/Colors";
import gradientFrostedPurple from "assets/v2/images/gradientFrostedPurple.png"

interface CampaignImageSymphonyProps {
    className: string;
    style?: CSSProperties;
    campaignMetadata: CampaignMetadata;
    isBackgroundImage?: boolean;
    iconSize?: number;
}

const CampaignImageSymphony = ({
    className,
    style,
    campaignMetadata,
    isBackgroundImage = false,
    iconSize = 40
}: CampaignImageSymphonyProps) => {
    const campaignType = campaignMetadata?.campaign_type || campaignMetadata?.playbook;
    const colorPlaybook = getCampaignTypeInfo(campaignType as CampaignType).color;

    let baseImage: string | undefined = campaignMetadata?.v2_campaign_input?.campaignImage

    if (!baseImage) {
        baseImage = campaignMetadata?.content?.thumbnail_url
    }

    if (!baseImage ||
        campaignType as any === PlaybookType.BOOST_INSTAGRAM_ENGAGEMENT ||
        campaignType as any === PlaybookType.GROW_PLAYLIST_FOLLOWERS
    ) {
        return (
            <div
                className={clsx(
                    "campaignImageSymphonyElement_icon",
                    className,
                )}
                style={styx(
                    sty.campaignImageSymphonyElement_icon,
                    { backgroundColor: colorPlaybook },
                    style,
                )}
            >
                <Icon
                    className="campaignCardSymphonyCampaignImageIcon"
                    icon={getCampaignTypeInfo(campaignType as CampaignType).icon}
                    size={iconSize}
                />
            </div>
        )
    }

    if (isBackgroundImage) {
        return (
            <div
                className={clsx(
                    "campaignImageSymphonyElement_backgroundImage",
                    className,
                )}
                style={styx(
                    sty.campaignImageSymphonyElement_backgroundImage,
                    {
                        backgroundImage: `url(${baseImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundColor: colorPlaybook,
                    },
                    style
                )}
                role="img"
            />
        );
    }

    return (
        <img
            className={clsx(
                "campaignImageSymphonyElement_image",
                className,
            )}
            style={styx(
                sty.campaignImageSymphonyElement_image,
                { backgroundColor: colorPlaybook },
                style,
            )}
            src={baseImage}
            onError={(e) => {
                const img = e.currentTarget;
                if (img.src !== gradientFrostedPurple) {
                    img.src = gradientFrostedPurple;
                }
            }}
            alt="Campaign Image"
        />
    )
}

const sty: Record<string, CSSProperties> = {
    campaignImageSymphonyElement_image: {
        ...Sty.text14grey,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 80,
        height: 80,
        borderRadius: 16,
        backgroundColor: Colors.purpleLightest,
        flexShrink: 0,
    },
    campaignImageSymphonyElement_backgroundImage: {
        ...Sty.text14grey,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 80,
        height: 80,
        borderRadius: 16,
        backgroundColor: Colors.purpleLightest,
        flexShrink: 0,
    },
    campaignImageSymphonyElement_icon: {
        ...Sty.text14grey,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 80,
        height: 80,
        borderRadius: 16,
        backgroundColor: Colors.purpleLightest,
        flexShrink: 0,
    }
}

export default CampaignImageSymphony;